<template>
  <div class="__scale_guide">
      <div class="instruction">
        <div>
          <h3>Click on Annual Zone {{currentStep}}</h3>
          <div class="feedback">
            <p :class="{'correct':answered}">{{feedback}}</p>
            <b-button v-show="answered && currentStep !== 3" @click="next" rounded>next</b-button>
            <b-button v-show="currentStep == 3 && answered" @click="reset()" rounded>reset</b-button>
          </div>
        </div>
      </div>
      <div class="scale">
        <svg
          version="1.1"
          id="scale"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 1000 959"
          style="enable-background:new 0 0 1000 959;"
          xml:space="preserve"
        >
          <image
            style="overflow:visible;"
            width="1000"
            height="959"
            xlink:href="/img/17-NK8103F001.jpg"
          />
          <g id="Annual1" @click="AnnularClick(1)" :class="{'correct':az[0] == 1, 'incorrect':az[0] == 2}">
            <path
              d="M484.6,637.93l24.15,9.39,165,112.24c3.13-6.7,16.1-42.48,19.23-46.06s20.58-25,21-27.28,14.31-25,14.31-25-.44-28.62,0-37.57.9-31.75,0-36.67-13.41-25-13.86-27.72-5.81-26.84-8.05-32.2-10.73-24.6-11.63-29.52-6.71-25-9.39-30-9.84-14.76-11.63-15.65S638,414.32,636.2,413s-21.47-17.44-24.15-20.12-24.6-19.68-26.83-22.36-19.68-18.34-22.36-19.23-28.62-12.08-28.62-12.08H513.66s-21.91,8.05-25.93,8.95-32.65,6.7-32.65,6.7-14.76.45-17.44.45-26.39,8.95-26.39,8.95l-11.62,3.57s-8.05-.89-9.39-.44-3.13.44-5.82,2.23-3.58,1.79-5.81,4.92-5.81,7.16-5.81,7.16,0,1.34-2.24,3.57-5.81,3.58-8.05,8.05-5.37,7.61-9.39,12.08S333.89,426,333.89,428.63,324.05,447,321.81,449.2,310.63,464,308,468.43s-11.63,23.71-11.63,25.5-6.71,28.17-6.71,30.41-4,34.43-4,34.43S282,578,280.22,580.24s-13,16.54-12.52,21,1.79,16.55-.45,22.36-8.49,26.84-8.49,26.84Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="Annual2" @click="AnnularClick(2)" :class="{'correct':az[1] == 1, 'incorrect':az[1] == 2}">
            <path
              d="M258.76,650.45s6.26-21,8.49-26.84.9-17.88.45-22.36,10.73-18.78,12.52-21,5.37-21.47,5.37-21.47,4-32.2,4-34.43,6.71-28.63,6.71-30.41,8.95-21,11.63-25.5,11.63-17,13.86-19.23,12.08-17.88,12.08-20.57,15.2-18.78,19.23-23.25,7.15-7.6,9.39-12.08,5.81-5.81,8.05-8.05,2.24-3.57,2.24-3.57,3.57-4,5.81-7.16,3.13-3.13,5.81-4.92,4.47-1.79,5.82-2.23,9.39.44,9.39.44l11.62-3.57s23.71-8.95,26.39-8.95,17.44-.45,17.44-.45,28.62-5.81,32.65-6.7,25.93-8.95,25.93-8.95h20.58s25.93,11.18,28.62,12.08S583,367.81,585.22,370.5s24.15,19.67,26.83,22.36S634.41,411.64,636.2,413s35.78,38,37.56,38.91,9,10.73,11.63,15.65,8.5,25,9.39,30,9.39,24.15,11.63,29.52,7.6,29.51,8.05,32.2,13,22.8,13.86,27.72.45,27.73,0,36.67,0,37.57,0,37.57S714.46,684,714,686.22s-17.89,23.71-21,27.28-16.1,39.36-19.23,46.06l86.31,66.64s7.61-17.89,11.18-23.26,5.37-14.31,6.27-17.88,13.41-19.68,13.41-19.68,4-12.08,6.26-14.76,10.29-15.2,12.52-17,6.71-16.55,8.5-20.13S823.58,701,824,698.3s3.58-13.42,6.27-18.34,1.78-9.84,4.47-14.31.44-30.41,0-37.12-10.29-54.56-9-54.56-12.52-30-13-32.64-5.36-6.71-6.26-13-2.23-8.5-3.57-16.55-2.24-19.67-3.88-29.51-1.49-11.18-.15-17.44-7.15-17-7.15-23.26S781.54,421,781.09,414.77s-17.89-18.34-18.33-19.68-29.07-22.8-29.52-24.59-15.65-13.42-17.89-16.1-24.15-25.49-24.15-25.49L676,312.81s-23.7-21-26.39-23.26S629,278.37,629,278.37s-8.94-12.52-10.28-15.2-9-5.82-12.52-8.5-9.84-6.71-13-8.94-11.63-5.82-14.76-7.61-13.86-7.6-18.34-9.83A29.1,29.1,0,0,0,549,225.6c-1.34,0-15.65,1.79-17.44,3.58s-23.25,0-23.25,0l-14.5,2.68s-19,3.58-23.51,4.92-22.36,0-22.36,0-14.32,7.16-15.21,8.5-19.23,1.79-19.23,1.79-23.7,2.68-25,2.68S367,260.48,365.19,261.83s-4.92.89-8.49.89-8.5-.89-12.53-.89-9.39,8.49-9.39,8.49-18.33,20.57-21.46,23.26S291,316.38,291,316.38s-10.29,14.32-12.53,17.89-24.14,29.52-25.93,30S236,395.09,227.45,396s-18.33,31.75-18.33,33.09-16.55,31.75-15.9,33.09S193,493,193,493s.45,42.49,0,44.27-9.84,45.17-9.84,45.17l-16.1,51.43Z"
              transform="translate(0 0)"
            />
          </g>
          <g id="Annual3" @click="AnnularClick(3)" :class="{'correct':az[2] == 1, 'incorrect':az[2] == 2}">
            <path
              d="M167.08,633.9l16.1-51.43s9.39-43.38,9.84-45.17S193,493,193,493s.84-29.51.2-30.86,15.9-31.75,15.9-33.09S219,396.88,227.45,396s23.26-31.31,25.05-31.75,23.7-26.39,25.93-30S291,316.38,291,316.38s19.23-20.12,22.36-22.8,21.46-23.26,21.46-23.26,5.37-8.49,9.39-8.49,8.95.89,12.53.89,6.7.45,8.49-.89,21.92-12.08,23.26-12.08,25-2.68,25-2.68,18.34-.45,19.23-1.79,15.21-8.5,15.21-8.5,17.88,1.34,22.36,0,23.51-4.92,23.51-4.92l14.5-2.68s21.46,1.79,23.25,0,16.1-3.58,17.44-3.58a29.1,29.1,0,0,1,11.18,2.69c4.48,2.23,15.21,8.05,18.34,9.83s11.63,5.37,14.76,7.61,9.39,6.26,13,8.94,11.18,5.81,12.52,8.5S629,278.37,629,278.37s17.89,8.95,20.57,11.18S676,312.81,676,312.81l15.2,16.1s21.92,22.8,24.15,25.49,17.45,14.31,17.89,16.1,29.07,23.25,29.52,24.59,17.89,13.42,18.33,19.68,10.74,20.57,10.74,26.83,8.49,17,7.15,23.26-1.5,7.6.15,17.44,2.53,21.46,3.88,29.51,2.68,10.29,3.57,16.55,5.82,10.29,6.26,13,14.32,32.64,13,32.64,8.5,47.86,9,54.56,2.68,32.65,0,37.12S833,675,830.29,680s-5.82,15.65-6.27,18.34-4,11.63-5.81,15.2-6.26,18.34-8.5,20.13-10.28,14.31-12.52,17-6.26,14.76-6.26,14.76-12.52,16.1-13.41,19.68-2.69,12.52-6.27,17.88-11.18,23.26-11.18,23.26,60.38,25.49,61.72,25,4-13.86,5.81-16.1,8.46-22.36,8.46-22.36,23.74-29.51,26.87-35.33,8.5-17,10.73-19.67,7.61-20.13,13.87-27.73,9.84-19.68,13-27.28,1.79-13,3.13-25.94.44-17.44,1.34-27.28-6.26-21.46-7.16-35.77-4.92-25.49-4-31.76-11.63-37.56-11.63-43.37-8.94-22.36-9.84-28.18-5.81-19.68-5.36-23.7-5.82-16.1-6.71-17.89.89-20.12,0-25-2.24-7.6-3.13-16.1-4-13.42-3.58-19.68-10.29-30-11.63-32.64-8.94-10.29-10.28-11.18-6.26-9.84-10.74-13-10.73-9.84-13.41-13-7.6-7.16-12.08-10.74-12.07-9.39-13.86-10.73-13.86-12.07-17.44-17-11.63-8.5-13.86-13.42S710,250.2,710,250.2s-28.62-27.73-31.31-30.86-13.86-15.2-18.78-19.23a50.63,50.63,0,0,0-12.07-7.6c-3.13-1.34-9.84-7.6-11.63-8.5S627.7,172.38,625,170.6,605.34,159.42,603.11,159s-25.94-8.5-31.31-9.84-14.76-.45-17-.89-24.15-.45-25.94-.9-13,0-17.44-1.34-24.6,6.26-26.83,6.26S467.16,159,467.16,159s-30-.45-34.89,0-13.86,4.47-15.65,5.37-41.59,8.49-43.82,9.39-13.87,8.05-17.89,10.28-21,4.47-24.6,4.47-20.12,8.5-22.81,9.4-26.38,17.44-29.07,21-14.31,19.68-14.75,22.36-28.62,25.05-30,27.28-17.88,27.28-17.88,27.28-25.49,39.8-28.18,43.83-22.36,31.3-23.7,32.65-19.23,43.82-19.23,43.82-8.05,57.69-8.05,63.39S132.2,519,132.2,519s-5.37,16.1-4.92,18.33-8,24.6-8.5,33.54-13,48.75-13,48.75Z"
              transform="translate(0 0)"
            />
          </g>
        </svg>
      </div>
    </div>
    <!-- <div class="controls">
      <b-button @click="prev" rounded :disabled="currentStep == 1">prev</b-button>
      <span
        v-for="(s, index) in steps"
        :key="index"
        :class="[{ active:currentStep == index +1 }, 'step']"
      >
        <svg id="dot" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.36 5.36">
          <g id="dot" v-show="currentStep == index + 1">
            <circle class="cls-1" cx="2.68" cy="2.68" r="2.18" />
          </g>
          <g id="ring">
            <circle class="cls-2" cx="2.68" cy="2.68" r="2.18" />
          </g>
        </svg>
      </span>
      <b-button @click="next" rounded :disabled="currentStep == steps">next</b-button>
    </div> -->
</template>

<script>
import { BButton } from "buefy/src/components/button";

export default {
  name: "ScaleGuide",
  components: {
    BButton
  },
  data() {
    return {
      currentStep: 1,
      steps: 5,
      az: [0, 0, 0],
      feedback: '',
      answered: false,
    };
  },
  methods: {
    next() {
      if (this.currentStep < this.steps) {
        this.currentStep += 1;
        this.answered = false;
        this.feedback = '';
        this.az = [0,0,0]
      }
    },
    reset() {
      this.currentStep = 1;
      this.answered = false;
      this.feedback = '';
      this.az = [0,0,0]
    },
    AnnularClick(which) {
      if (!this.answered) {
        if (which == this.currentStep) {
          this.az[which - 1] = 1
          this.feedback = "Correct!"
          this.answered = true;
        } else {
          this.az[which - 1] = 2
          this.feedback = "Incorrect, try again."
          setTimeout(() => {
            this.az[which - 1] = 0
            this.feedback = ''
          }, 1500);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.__scale_guide {
  width: 70%;
  margin: 50px 0px;

  .instruction {
    border-radius: 30px 30px 0 0;
    background-color: #f8f8f8;
    height: 70px;
    text-align: center;
    padding-top: 20px;
    margin-bottom: -30px;
    position: relative;

    .feedback {
      position: absolute;
      font-weight: 700;
      font-size: 18px;
      color: red;
      width: 100%;
      top: 80px;
    }
  }

  #scale {
    border-radius: 30px;
    box-shadow: 3px 3px 6px #00000030;
  }

  #Annual1 {
    opacity: 0.5;
    fill: transparent;
  }
  #Annual2 {
    opacity: 0.5;
    fill: transparent;
  }
  #Annual3 {
    opacity: 0.5;
    fill: transparent;
  }

  .correct {
    fill: green !important;
    color: green;
  }

  .incorrect {
    fill: red !important;
  }

  .step {
    color: gray;
  }

  .active {
    color: red;
  }

  .st5 {
    fill: none;
    stroke: #000000;
    stroke-width: 5;
    stroke-miterlimit: 10;
  }

  .controls {
    width: 250px;
    margin: 0 auto;
  }

  #dot {
    width: 10px;
    height: 10px;
    margin: 12px 4px 0px 4px;
  }

  .cls-1 {
    fill: #a7a9ac;
  }

  .cls-2 {
    fill: none;
    stroke: #a7a9ac;
    stroke-miterlimit: 10;
  }
}
</style>